import { css } from 'emotion';

import { colors, fonts } from '../../styles';

export const iconBefore = css`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: flex-end;
`;

export const stringLabel = css`
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${colors.gray.dark};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.regular};
  white-space: nowrap;
`;
